/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Passkey_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a name for your passkey" |
*
* @param {Profile_Security_Passkey_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_passkey_placeholder = /** @type {((inputs?: Profile_Security_Passkey_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Passkey_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib einen Namen für deinen Passkey ein")
	return /** @type {LocalizedString} */ ("Enter a name for your passkey")
});